/* Dressing room: the tabs pick a look. The friend on stage is lifted off and the next one drops onto its keys / bag / hook,
   then keeps swinging gently. The swing moves every display frame (WH.onTick), only while the stage is on screen. */
(function () {
  'use strict';
  var WH = window.WH;
  if (!WH) return;
  WH.register('backstage', function (sec) {
    var tabs = Array.prototype.slice.call(sec.querySelectorAll('[data-look-tab]'));
    var looks = Array.prototype.slice.call(sec.querySelectorAll('[data-look]'));
    var notes = Array.prototype.slice.call(sec.querySelectorAll('[data-look-note]'));
    var stage = sec.querySelector('.wh-back__stage');
    if (!tabs.length || !looks.length) return;
    var cur = 0, busy = false;
    var friend = function (i) { return looks[i] && looks[i].querySelector('[data-look-friend]'); };
    var swinger = function (i) { return looks[i] && looks[i].querySelector('[data-look-swing]'); };

    /* pendulum: angle a (deg), speed v; kicked by a drop or a hover, idles with a slow sway */
    var a = 0, v = 0, t0 = 0, on = false;
    function kick(s) { v += s; }
    function show(i, focus) {
      if (i === cur || busy) return;
      var from = looks[cur], to = looks[i], ff = friend(cur), tf = friend(i);
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); t.tabIndex = k === i ? 0 : -1; });
      if (focus) tabs[i].focus();
      notes.forEach(function (n, k) { n.hidden = k !== i; });
      cur = i;
      WH.sound.play('pop');
      if (!WH.anim || !ff || !tf) { from.hidden = true; to.hidden = false; return; }
      busy = true;
      gsap.to(ff, { yPercent: -125, rotation: WH.rand(-10, 10), duration: 0.3, ease: WH.sm('back.in(1.7)', 0.3), onComplete: function () {
        from.hidden = true;
        gsap.set(ff, { clearProps: 'transform' });
        to.hidden = false;
        a = 0; v = 0;
        var r = stage.getBoundingClientRect();
        WH.puff(r.left + r.width / 2, r.top + r.height * 0.22, 9);
        gsap.fromTo(tf, { yPercent: -115, rotation: 0 }, { yPercent: 0, duration: 0.55, ease: WH.sm('bounce.out', 0.55), onComplete: function () { busy = false; kick(WH.rand(-1, 1) > 0 ? 70 : -70); } });
      } });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
      t.addEventListener('keydown', function (e) {
        var k = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
        if (!k) return;
        e.preventDefault();
        show((cur + k + tabs.length) % tabs.length, true);
      });
    });
    looks.forEach(function (l) {
      var f = l.querySelector('[data-look-friend]');
      if (f) f.addEventListener('pointerenter', function () { kick(a >= 0 ? 55 : -55); WH.sound.play('squeak'); });
    });
    if (WH.reduce) return;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { on = en[0].isIntersecting; }).observe(stage);
    else on = true;
    WH.onTick(function (dt, now) {
      if (!on) return;
      if (!t0) t0 = now;
      var idle = Math.sin((now - t0) / 1000 * 1.3) * 2.2;
      v += (-(a - idle) * 38 - v * 3.2) * dt;
      a += v * dt;
      var s = swinger(cur);
      if (s) s.style.transform = 'rotate(' + a.toFixed(2) + 'deg)';
    });
  });
})();
